import clsx from 'clsx';

interface Props {
  /** Extra classes (e.g. margins) for the wrapping chip. */
  className?: string;
}

/**
 * Small amber "PAUSED" chip for a locked org's rail section headers and the
 * top-left org indicator (PR 6). Never says "suspended".
 */
export default function PausedChip({ className }: Props) {
  return (
    <span
      className={clsx(
        'shrink-0 rounded bg-[#FEF3C7] px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-[#92400E]',
        className
      )}
    >
      Paused
    </span>
  );
}
